import { composeWithDevTools } from '@redux-devtools/extension'
import { legacy_createStore as createStore, applyMiddleware } from 'redux'
import { createEpicMiddleware } from 'redux-observable'
import { createBrowserHistory } from 'history'
import rootReducer from '../reducers'
import rootEpic from '../epics'
import LogRocket from 'logrocket'
import { createReduxHistoryContext } from 'redux-first-history'

const { createReduxHistory, routerMiddleware, routerReducer } =
  createReduxHistoryContext({
    history: createBrowserHistory({ basename: process.env.PUBLIC_URL })
  })

const getStore = () => {
  const composeEnhancers = composeWithDevTools({})
  const epicMiddleware = createEpicMiddleware()

  const store = createStore(
    rootReducer(routerReducer),
    composeEnhancers(
      applyMiddleware(
        routerMiddleware,
        epicMiddleware,
        LogRocket.reduxMiddleware({
          stateSanitizer: function (state) {
            return {
              ...state,
              member: {
                ...state.member,
                members: state.member?.members?.map(member => ({
                  ...member,
                  ssn: undefined
                }))
              }
            }
          }
        })
      )
    )
  )

  epicMiddleware.run(rootEpic)

  return store
}

export const store = getStore()

export const history = createReduxHistory(store)
